import { SVGProps, Ref, forwardRef } from 'react';

export const UserSinglePlusOutlinedSize24Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M19 14a5 5 0 1 1 0 10 5 5 0 0 1 0-10m-.9 4.1H16v1.8h2.1V22h1.8v-2.1H22v-1.8h-2.1V16h-1.8z"
                    fill="currentColor"
                />
                <path
                    d="M10.003 15c.67 0 1.341.049 1.997.152v1.828c-.634-.12-1.304-.18-1.997-.18-2.027 0-3.86.503-5.152 1.561-.919.753-1.692 1.89-2.026 3.639H1.003c.823-5.202 4.91-7 9-7"
                    fill="currentColor"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.379 2.008c3.707.159 5.035 2.659 5.117 5.234l.004.258c0 2.75-1.375 5.5-5.5 5.5s-5.5-2.75-5.5-5.5l.004-.258C4.588 4.581 6.004 2 10 2zM10 3.8c-1.63 0-2.457.522-2.914 1.071C6.58 5.478 6.3 6.392 6.3 7.5s.28 2.022.786 2.629C7.543 10.678 8.37 11.2 10 11.2s2.457-.522 2.914-1.071c.506-.607.786-1.521.786-2.629s-.28-2.022-.786-2.629C12.457 4.322 11.63 3.8 10 3.8"
                    fill="currentColor"
                />
            </g>
        </svg>
    )
);
UserSinglePlusOutlinedSize24Glyph.displayName = 'UserSinglePlusOutlinedSize24Glyph';
